export default {
    routerName: '刊物詳細',
    journal: {
        title: 'タイトル',
        type: 'タイプ',
        monthJournal: '月刊',
        dayJournal: '日刊',
        image: '刊物アイコン',
        thumb: 'サムネイル',
        releaseDate: '発刊日付',
        body: '目録',
        description: '記述',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
    },
};
